<template>
	<div class="seo-skills-panel">
		<a :href="card.link" class="seo-skill-card" v-for="(card, idx) in cards" :key="idx" target="_blank">
			<div class="seo-skill-icon">
				<font-awesome-icon :icon="card.icon" />
			</div>
			<div class="seo-skill-content">
				<div class="seo-skill-title">{{ card.title }}</div>
				<div class="seo-skill-desc">{{ card.desc }}</div>
				<span class="seo-skill-cta">{{ card.cta }}</span>
			</div>
		</a>
	</div>
</template>

<script>
export default {
	name: "SeoSkillsPanel",
	data() {
		return {
			cards: [
				{
					icon: "book",
					title: "Free SEO Course",
					desc: "Learn SEO step by step with our video course",
					cta: "Start Course",
					link: "https://rankcaddy.onlinecoursehost.com/courses/anchor-seo",
				},
				{
					icon: "check-square",
					title: "Ultimate SEO Checklist",
					desc: "A complete checklist for better rankings",
					cta: "Download",
					link: "https://rankcaddy.io/free-resources/seo-checklist/",
				},
				{
					icon: "bolt",
					title: "SEO Quick Wins Cheatsheet",
					desc: "Easy wins to improve your SEO today",
					cta: "Get Cheatsheet",
					link: "https://rankcaddy.io/free-resources/seo-quick-wins-cheatsheet/",
				},
			],
		};
	},
	methods: {
	},
};
</script>

<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
@import './../../assets/css/less/_helper.less';
.seo-skills-panel {
	display: flex;
	gap: 20px;
	margin-top: 20px;
	.seo-skill-card {
		display: flex;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 8px rgba(60, 60, 60, 0.06);
		padding: 18px 22px;
		align-items: center;
		flex: 1 1 0;
		min-width: 0;
		cursor: pointer;
		text-decoration: none;
		.trans;
		.seo-skill-icon {
			font-size: 2.5rem;
			color: @formDefaultColour;
			margin-right: 18px;
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 48px;
			height: 48px;
			background: #f5f7fa;
			border-radius: 50%;
			svg {
				height: 0.8em;
			}
		}
		.seo-skill-content {
			flex: 1;
			.seo-skill-title {
				font-weight: bold;
				font-size: 1.25rem;
				margin-bottom: 4px;
				text-decoration: none;
			}
			.seo-skill-desc {
				font-size: 0.98rem;
				color: #555;
				margin-bottom: 8px;
				text-decoration: none;
			}
			.seo-skill-cta {
				color: @formDefaultColour;
				font-weight: 600;
				font-size: 0.98rem;
				text-decoration: none;
			}
		}
		&:hover {
			.seo-skill-content {

				.seo-skill-cta {

					text-decoration: underline;

				}

			}
		}
	}
}
@media (max-width: 900px) {
	.seo-skills-panel {
		flex-direction: column;
		.seo-skill-card {
			margin-bottom: 12px;
		}
	}
}
</style>
